import { render, staticRenderFns } from "./EmrPage.vue?vue&type=template&id=06ba862c&scoped=true"
import script from "./EmrPage.vue?vue&type=script&lang=js"
export * from "./EmrPage.vue?vue&type=script&lang=js"
import style0 from "./EmrPage.vue?vue&type=style&index=0&id=06ba862c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "06ba862c",
  null
  
)

export default component.exports